<template>
<div>
    <v-card>
        <v-card-title>
            <v-layout row wrap align-center>
                <v-flex xs12 md6>
                    <v-layout row align-center>
                        <v-icon style="font-size: 34px; padding-right: 15px;">face</v-icon>
                        <h2 class="display-1">{{student.first_name}} {{student.last_name}} - Grade {{student.grade}}</h2>
                    </v-layout>
                </v-flex>
                <v-flex xs12 md6>
                    <v-btn class="primary right" @click="print()">
                        <v-icon>print</v-icon>
                        Download Schedule
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-card-title>
        <v-card-text>
            <h3 class="primary white--text display-1 mt-5 pa-2">Enrolled Classes</h3>
            <v-data-table :headers="headers" :items="enrolledClasses" hide-actions>
                <template slot="items" slot-scope="props">
                    <tr>
                        <td class="text-xs-center">{{ props.item.section }}</td>
                        <td class="text-xs-left">{{ props.item.name }}</td>
                        <td class="text-xs-center">{{ props.item.teacher.last_name }}</td>
                        <td class="text-xs-center">{{ props.item.room }}</td>
                        <td class="text-xs-center">{{ props.item.days }}</td>
                        <td class="text-xs-center">{{ props.item.time }}</td>
                        <td class="text-xs-center">{{ props.item.period }}</td>
                        <td class="text-xs-center">
                            <v-btn class="red white--text" :disabled="semester.disabled === 1" @click="initActionDialog('drop_enrollment', props.item)">Drop</v-btn>
                        </td>
                    </tr>
                </template>
            </v-data-table>
            <h3 class="primary white--text display-1 mt-5 pa-2">Waitlist Classes</h3>
            <v-data-table :headers="headers" :items="waitlistClasses" hide-actions>
                <template slot="items" slot-scope="props">
                    <tr>
                        <td class="text-xs-center">{{ props.item.section }}</td>
                        <td class="text-xs-left">{{ props.item.name }}</td>
                        <td class="text-xs-center">{{ props.item.teacher.last_name }}</td>
                        <td class="text-xs-center">{{ props.item.room }}</td>
                        <td class="text-xs-center">{{ props.item.days }}</td>
                        <td class="text-xs-center">{{ props.item.time }}</td>
                        <td class="text-xs-center">{{ props.item.period }}</td>
                        <td class="text-xs-center">
                            <v-btn class="red white--text" :disabled="semester.disabled === 1" @click="initActionDialog('drop_waitlist', props.item)">Remove</v-btn>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>

    <v-dialog v-model="actionDialog.active" persistent max-width="500px">
        <v-card>
            <v-card-title>
                <h5 class="headline">{{ actionDialog.message }}</h5>
            </v-card-title>
            <v-card-text>
                <h6 class="title primary--text">{{ selectedCourse.section }} | {{ selectedCourse.name }}</h6>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red lighten-4" @click="actionDialog.active = false">No</v-btn>
                <v-btn color="green lighten-4" @click.native="executeAction()">Yes</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog persistent v-model="classStatusAlert" max-width="500px">
        <v-card>
            <v-card-text>
                <v-progress-linear v-if="progress" indeterminate :size="100" :width="10" style="text-align: center;" color="primary" background-color="warning">
                </v-progress-linear>
                <div v-else>
                    <v-alert :value="httpResponse.code === 200" type="success" v-text="httpResponse.message"></v-alert>
                    <v-alert :value="httpResponse.code === 202" type="warning" v-text="httpResponse.message"></v-alert>
                    <v-alert :value="httpResponse.code === 422" type="error" v-text="httpResponse.message"></v-alert>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-btn v-if="!progress" color="primary" flat @click.stop="closeAlert">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import {
    printSchedule
} from '@/helpers/printStudentSchedule.js'

export default {
    props: {
        semester: {
            type: Object
        }
    },
    data() {
        return {
            selectedCourse: {}, // course to drop or remove from waitlist
            actionDialog: {
                active: false,
                message: '',
                action: ''
            },
            classStatusAlert: false,
            progress: false,
            headers: [{
                    text: 'Section',
                    sortable: true,
                    align: 'center',
                    value: 'section',
                    width: '5%'
                },
                {
                    text: 'Name',
                    sortable: true,
                    align: 'left',
                    value: 'name',
                    width: '20%'
                },
                {
                    text: 'Teacher',
                    sortable: true,
                    align: 'center',
                    value: 'teacher.last_name',
                    width: '20%'
                },
                {
                    text: 'Room',
                    sortable: true,
                    align: 'center',
                    value: 'room',
                    width: '5%'
                },
                {
                    text: 'Days',
                    sortable: true,
                    align: 'center',
                    value: 'days',
                    width: '10%'
                },
                {
                    text: 'Time',
                    sortable: true,
                    align: 'center',
                    value: 'time',
                    width: '10%'
                },
                {
                    text: 'Period',
                    sortable: true,
                    align: 'center',
                    value: 'period',
                    width: '10%'
                },
                {
                    text: 'Action',
                    sortable: false,
                    align: 'center',
                    value: 'action',
                    width: '20%'
                }
            ]
        }
    },
    computed: {
        culprit() {
            return this.$store.getters.culprit
        },
        enrolledClasses() {
            return this.$store.state.enrollment.schedule.enrolled
        },
        waitlistClasses() {
            return this.$store.state.enrollment.schedule.waiting
        },
        student() {
            return this.$store.state.enrollment.student
        },
        formattedSchedule() {
            return this.$store.getters.formattedStudentSchedule
        },
        httpResponse() {
            return this.$store.state.enrollment.httpResponse
        }
    },
    methods: {
        print() {
            printSchedule(this.student, this.formattedSchedule, this.semester.name)
        },
        initActionDialog(action, course) {
            this.selectedCourse = course
            this.actionDialog.active = true
            if (action === 'drop_waitlist') {
                this.actionDialog.message = 'Are you sure you want to be removed from the wait list?'
                this.actionDialog.action = 'drop_waitlist'
            } else if (action === 'drop_enrollment') {
                this.actionDialog.message = 'Are you sure you want to drop this class?'
                this.actionDialog.action = 'drop_enrollment'
            }

        },
        executeAction() {
            const payload = {
                course_id: this.selectedCourse.id,
                student_id: this.student.id,
                culprit: this.culprit
            }

            this.actionDialog.active = false
            this.classStatusAlert = true
            this.progress = true

            if (this.actionDialog.action === 'drop_waitlist') {

                // timer to slow down the user and space out the api calls
                setTimeout(() => {
                    this.$store.dispatch('removeFromWaitlist', payload)
                        .then(() => {
                            this.progress = false
                        })
                        .catch(() => {
                            this.progress = false
                        })
                }, 2000)

            } else if (this.actionDialog.action === 'drop_enrollment') {

                // timer to slow down the user and space out the api calls
                setTimeout(() => {
                    this.$store.dispatch('dropClass', payload)
                        .then(() => {
                            this.progress = false
                        })
                        .catch(() => {
                            this.progress = false
                        })
                }, 2000)

            }

        },
        closeAlert() {
            this.classStatusAlert = false
            this.progress = false
            this.actionDialog = {
                active: false,
                message: '',
                action: ''
            }
            this.$store.commit('clearEnrollmentHttpResponse')
        }
    }
}
</script>
